/* eslint-disable react/no-array-index-key,no-undef,react/jsx-props-no-spreading,react-hooks/exhaustive-deps,array-callback-return,no-shadow */
import React, { useState, useEffect, useMemo } from "react";

import {
  Card,
  Radio,
  Select,
  DatePicker,
  Form,
  Button,
  Divider,
  Row,
  Col,
  Checkbox,
  Tooltip,
  Modal,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { useHistory, useParams } from "react-router-dom";
import find from "lodash/find";
import omit from "lodash/omit";
import moment from "moment";
import {
  displayFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { addBill, fetchBillsByAggId } from "../../store/slices/bills";
import {
  fetchAgrStatus,
  fetchBillStatus,
  fetchBillType,
  fetchPayStatus,
  fetchServiceStatus,
} from "../../store/slices/rtkDictionaries";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { setBillsFaximileWith } from "../../store/slices/settings";
import MultipleSelect from "../common/MultipleSelect";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { toHttpFormat } from "../../lib/utils";
import { fetchDocumentTemplates } from "../../store/slices/documentTemplates";
import { fetchServiceAgreementVersions } from "../../store/slices/services";

const styles = {
  selectAgreement: {
    width: "100%",
  },
  selectService: {
    width: "100%",
  },
  selectTemplate: {
    width: "150px",
  },
  emails: {
    width: "360px",
    height: "138px",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    color: "#8c8c8c",
  },
  radioStyle: {
    lineHeight: "30px",
  },
  checkbox: {
    marginTop: "5px",
  },
};

const { RangePicker } = DatePicker;
const { Option } = Select;
const dateFormat = displayFormat;

const AccountNewInvoicing = ({
  cancelText = "Назад",
  isOnlyByService = false,
  toggleServicesIncludePastDates,
  isServicesIncludePastDates,
}) => {
  const dispatch = useDispatch();
  const { accountId } = useParams();
  const { account } = useSelector((state) => state.accounts);
  const [radioValue, setRadioValue] = useState(2);
  const { serviceDetails: product } = useSelector((state) => state.service);
  const { productsList, productsListLoading } = useSelector((state) => state.products);
  const { agreements } = useSelector((state) => state.agreements);
  const { serviceStatus, agrStatusLoading, agrStatus } = useSelector(
    (state) => state.rtkDictionaries
  );
  const { addBillLoading } = useSelector((state) => state.bills);
  const [withEmails, setWithEmails] = useState(true);
  const history = useHistory();
  const [invoiceData, setInvoiceData] = useState();
  const [disabledFromDatesForCalendar, setDisabledFromDatesForCalendar] = useState("");
  const [disabledToDatesForCalendar, setDisabledToDatesForCalendar] = useState("");
  const { billsFaximileWith } = useSelector((state) => state.settings);
  const defaultSelectedStatuses = useMemo(
    () => agrStatus.map(({ id }) => id).filter((id) => id !== 6),
    [agrStatus]
  );
  const [selectedStatuses, setSelectedStatuses] = useState(defaultSelectedStatuses);
  const { templates, templatesLoading } = useSelector((state) => state?.documentTemplates);

  useEffect(() => {
    setSelectedStatuses(defaultSelectedStatuses);
  }, [defaultSelectedStatuses]);

  const [form] = Form.useForm();

  // Загрузка справочника статусов договора
  useEffect(() => {
    if (!checkIsLoaded(agrStatusLoading)) {
      dispatch(fetchAgrStatus());
    }
  }, []);

  useEffect(() => {
    if (isOnlyByService) {
      setInvoiceData({
        ...invoiceData,
        serviceIds: [product.id],
        agreementId: product?.agreement?.id,
        serviceStatusId: product.serviceStatusId,
      });
    }
  }, []);

  // Загрузка шаблонов
  useEffect(() => {
    const params = { reportTypeId: 1 };
    params.onDate = invoiceData?.fromDate
      ? toHttpFormat(invoiceData?.fromDate)
      : toHttpFormat(moment());
    dispatch(fetchDocumentTemplates(params));
  }, [invoiceData?.fromDate]);

  useEffect(() => {
    if (!isOnlyByService) {
      if (agreements && agreements?.length === 1) {
        setInvoiceData({
          ...invoiceData,
          agreementId: agreements[0]?.id,
        });
      }
    }
  }, [agreements[0]?.id]);

  const isByAgreement = radioValue === 1;

  const resetFields = () => {
    form.resetFields();
    setInvoiceData();
    setDisabledFromDatesForCalendar("");
    setDisabledToDatesForCalendar("");
  };

  const onChangeRadio = (e) => {
    resetFields();
    if (radioValue === 1) {
      setSelectedStatuses(defaultSelectedStatuses);
    }
    setRadioValue(e.target.value);
    toggleServicesIncludePastDates({
      target: {
        checked: false,
      },
    });
  };

  const onSelectAgreement = (value) => {
    setInvoiceData({
      ...invoiceData,
      agreementId: value,
    });

    const findAgreement =
      agreements &&
      agreements.length !== 0 &&
      agreements.filter((filter) => filter.id === value)[0];

    // Нужно ограничить дату по min(fromDate) - max(toDate) версий договора
    dispatch(fetchServiceAgreementVersions({ serviceAgreementIds: [findAgreement.id] })).then(({ payload }) => {
      const arrAgreements = payload[0];

      if (arrAgreements && arrAgreements.length > 0) {
        setDisabledFromDatesForCalendar(
          arrAgreements[0].fromDate ? toHttpFormatStartOfDay(arrAgreements[0].fromDate) : ""
        );
        setDisabledToDatesForCalendar(
          arrAgreements[arrAgreements.length - 1].toDate ? toHttpFormatEndOfDay(arrAgreements[arrAgreements.length - 1].toDate) : ""
        );
      }
    });
  };

  const onChangeServiceType = (value, { product }) => {
    setInvoiceData({
      ...invoiceData,
      agreementId: product.agreement.id,
      serviceIds: [value],
      serviceStatusId: product.serviceStatusId,
    });

    // Нужно ограничить дату по min(fromDate) - max(toDate) версий договора
    dispatch(fetchServiceAgreementVersions({ serviceAgreementIds: [service.agreementId] })).then(({ payload }) => {

      const arrAgreements = payload[0];

      if (arrAgreements && arrAgreements.length > 0) {
        setDisabledFromDatesForCalendar(
          arrAgreements[0].fromDate ? toHttpFormatStartOfDay(arrAgreements[0].fromDate) : ""
        );
        setDisabledToDatesForCalendar(
          arrAgreements[arrAgreements.length - 1].toDate ? toHttpFormatEndOfDay(arrAgreements[arrAgreements.length - 1].toDate) : ""
        );
      }
    });

    if (product.serviceStatusId === 4) {
      Modal.warning({
        title: "Внимание!",
        content: `Выбран продукт в статусе "Ожидает"`,
      });
    }
  };

  const getDisabledDates = (cur) => {
    if (disabledFromDatesForCalendar && disabledToDatesForCalendar) {
      const fromDateMoment = moment(disabledFromDatesForCalendar);
      const toDateMoment = moment(disabledToDatesForCalendar);
      return moment(cur).isBefore(fromDateMoment) || moment(cur).isAfter(toDateMoment);
    }
    return "";
  };

  const getAgreementsInitialValue = () => {
    let agreementDefault = invoiceData?.agreementId;
    if (agreements && agreements?.length === 1) {
      agreementDefault = agreements[0]?.id;
    }
    return agreementDefault;
  };

  const getAddedBillData = () => {
    const getAllIds = (productsList) => {
      const ids = [];

      const collectIds = (node) => {
        if (node?.id) {
          ids.push(node.id);
        }

        if (node?.children && node.children.length > 0) {
          node.children.forEach((child) => collectIds(child));
        }
      };

      collectIds(productsList);
      return ids;
    };

    const findService = productsList.find((product) => product.id === invoiceData.serviceIds?.[0]);

    const serviceIds = getAllIds(findService);

    const data = {
      ...omit(invoiceData, "serviceStatusId", "serviceIds"),
      sendBill: withEmails,
    };

    if (serviceIds.length) {
      data.serviceIds = serviceIds;
    }

    if (invoiceData.serviceStatusId === 4) {
      data.waited = true;
    }
    if (!withEmails) {
      delete data.reportId;
    }
    if (invoiceData.formatType === "PDF") {
      delete invoiceData.formatType;
    }
    return data;
  };

  const handleSubmit = async () => {
    // return console.log(getAddedBillData());
    await dispatch(addBill(getAddedBillData()));
    history.push(`/accounts/${accountId}/bills`);
    dispatch(fetchPayStatus());
    dispatch(fetchBillStatus());
    dispatch(fetchBillType());
    dispatch(fetchServiceStatus());
    if (agreements.length !== 0) {
      const aggArray = new Set();
      agreements.map((item) => {
        aggArray.add(item.id);
      });
      dispatch(fetchBillsByAggId({ aggId: [...aggArray] }));
    }
  };

  const renderSelectAgreement = () => (
    <Form.Item
      name="agreementId"
      rules={[{ required: isByAgreement, message: "Пожалуйста, выберите договор" }]}
      style={{ width: "100%" }}
    >
      <Select
        placeholder="Выберите договор"
        style={styles.selectAgreement}
        onChange={onSelectAgreement}
        value={isOnlyByService ? product.agreementNumber : getAgreementsInitialValue()}
        disabled={isOnlyByService || !isByAgreement}
      >
        {agreements &&
          agreements.length !== 0 &&
          agreements
            .filter(({ agreementStatusId }) => {
              if (selectedStatuses.length === 0) {
                return true;
              }
              return selectedStatuses.includes(agreementStatusId);
            })
            .map((item) => (
              <Option key={uuid()} value={item.id}>
                {item.agreementNumber}
              </Option>
            ))}
      </Select>
    </Form.Item>
  );

  const handleCheckServicesIncludePastDates = (e) => {
    toggleServicesIncludePastDates(e);
    resetFields();
  };

  const renderSelectServiceType = () => {
    const isAgreementVisible = agreements?.length > 1;
    const filteredServices = productsList.filter(
      ({ serviceProfile, serviceStatusId }) =>
        serviceProfile.paymentTypeId === 1 && serviceStatusId !== 5
    );

    const getTooltipTitle = (item) => {
      const cellStyle = {
        border: `1px solid rgba(0, 0, 0, 0.1)`,
        padding: "5px",
        color: "rgba(0, 0, 0, 0.3)",
        backgroundColor: "white",
      };
      return (
        <div style={{ display: "flex" }}>
          {isAgreementVisible && <div style={cellStyle}>{item.agreement.agreementNumber}</div>}
          <div style={cellStyle}>{item.serviceType?.name}</div>
          <div style={cellStyle}>{item.offering?.extName}</div>
          <div style={cellStyle}>{find(serviceStatus, { id: item.serviceStatusId })?.name}</div>
          <div style={cellStyle}>{moment(item.fromDate).format(displayFormat)}</div>
          <div style={cellStyle}>{moment(item.toDate).format(displayFormat)}</div>
          <div style={cellStyle}>{item.id}</div>
        </div>
      );
    };
    return (
      <Form.Item
        name="serviceId"
        rules={[
          {
            required: !isOnlyByService && !isByAgreement,
            message: "Пожалуйста, выберите продукт",
          },
        ]}
        initialValue={isOnlyByService ? product.id : null}
        style={{ width: "100%" }}
      >
        <Select
          placeholder="Выберите продукт"
          style={styles.selectService}
          onChange={onChangeServiceType}
          loading={checkIsLoading(productsListLoading)}
          disabled={isOnlyByService || isByAgreement}
        >
          {!isByAgreement &&
            !isOnlyByService &&
            filteredServices &&
            filteredServices.length !== 0 &&
            filteredServices.map((item) => (
              <Option key={uuid()} value={item.id} product={item}>
                <Tooltip
                  overlayInnerStyle={{
                    display: "inline-block",
                    whiteSpace: "nowrap",
                    padding: "0",
                  }}
                  title={getTooltipTitle(item)}
                >
                  {isAgreementVisible && (
                    <div>
                      {`${item.id} | ${item.agreement.agreementNumber} | ${item.serviceType?.name} | ${item.offering?.extName}`}
                    </div>
                  )}
                  {!isAgreementVisible && (
                    <div>{`${item.id} | ${item.serviceType?.name} | ${item.offering?.extName}`}</div>
                  )}
                </Tooltip>
              </Option>
            ))}
          {isOnlyByService && <Option value={product.id}>{product.serviceType.name}</Option>}
        </Select>
      </Form.Item>
    );
  };

  const renderSelectTemplates = () => (
    <Select
      placeholder="Выберите шаблон"
      style={styles.selectTemplate}
      loading={templatesLoading === loadingStatusCodes.pending}
      onChange={(value) => {
        setInvoiceData({
          ...invoiceData,
          reportId: value,
        });
      }}
    >
      {Array.isArray(templates) &&
        templates.length !== 0 &&
        templates.map((item) => (
          <Option key={uuid()} value={item.id}>
            {item.defaultTemplate ? `${item.name} (по умолчанию)` : item.name}
          </Option>
        ))}
    </Select>
  );

  const renderSelectFormat = () => (
    <Select
      placeholder="Выберите формат"
      style={styles.selectTemplate}
      defaultValue="PDF"
      onChange={(value) => {
        setInvoiceData({
          ...invoiceData,
          formatType: value,
        });
      }}
    >
      {[{ value: "PDF" }, { value: "XLSX" }].map((item) => (
        <Option key={uuid()} value={item.value}>
          {item.value}
        </Option>
      ))}
    </Select>
  );

  const renderCheckbox = () => (
    <Checkbox checked={withEmails} onChange={() => setWithEmails(!withEmails)}>
      <label>Отправить счет по адресам</label>
    </Checkbox>
  );

  const handleChangeBillsFaximileWith = () => {
    dispatch(setBillsFaximileWith(!billsFaximileWith));
  };

  const onChangeStatuses = (value) => {
    form.resetFields(["agreementId"]);
    setInvoiceData(omit(invoiceData, "agreementId"));
    setSelectedStatuses(value);
  };

  return (
    <Card title="Выставление счета на предоплату" bordered={false}>
      <Form onFinish={handleSubmit} form={form}>
        {isOnlyByService && (
          <Row>
            <Col span={9}>{renderSelectServiceType()}</Col>
          </Row>
        )}
        {!isOnlyByService && (
          <Radio.Group style={{ width: "100%" }} onChange={onChangeRadio} value={radioValue}>
            <Row>
              <Col span={11} style={{ display: "flex" }}>
                <Radio style={styles.radioStyle} value={1}>
                  По договору:
                </Radio>
                {renderSelectAgreement()}
              </Col>
              <Col offset={1} span={6}>
                <MultipleSelect
                  onChange={onChangeStatuses}
                  value={selectedStatuses}
                  allValues={agrStatus?.map(({ id }) => id) || []}
                  placeholder="Статус"
                  style={{ height: "30px" }}
                  allowClear
                  maxTagCount={1}
                  showSearch
                  filterOption={(value, { children }) =>
                    children.toLowerCase().includes(value.toLowerCase())
                  }
                  disabled={radioValue !== 1}
                >
                  {[...agrStatus]
                    .sort((a, b) => (a.id > b.id ? 1 : -1))
                    .map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                </MultipleSelect>
              </Col>
            </Row>
            <Row>
              <Col span={11} style={{ display: "flex" }}>
                <Radio style={styles.radioStyle} value={2}>
                  По продукту:
                </Radio>
                {renderSelectServiceType()}
              </Col>
              <Col offset={1}>
                <Checkbox
                  disabled={isByAgreement}
                  style={styles.checkbox}
                  checked={isServicesIncludePastDates}
                  onChange={handleCheckServicesIncludePastDates}
                >
                  Только закрытые
                </Checkbox>
              </Col>
            </Row>
          </Radio.Group>
        )}
        <Row />
        <Divider />
        <Row gutter={48}>
          <Col>
            <Form.Item
              label="Период счета"
              name="password"
              rules={[{ required: true, message: "Пожалуйста, введите период счёта" }]}
            >
              <RangePicker
                onChange={(value) => {
                  setInvoiceData({
                    ...invoiceData,
                    periodFrom: value ? toHttpFormatStartOfDay(value[0]) : "",
                    periodTo: value ? toHttpFormatEndOfDay(value[1]) : "",
                  });
                }}
                format={dateFormat}
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item name="datePicker" label="Дата счета">
              <DatePicker
                onChange={(value) => {
                  setInvoiceData({
                    ...invoiceData,
                    fromDate: value ? toHttpFormatStartOfDay(value) : "",
                  });
                }}
                format={dateFormat}
                disabledDate={getDisabledDates}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="formatType" label="Формат документа">
              {renderSelectFormat()}
            </Form.Item>
            <Form.Item name="reportId" label="Шаблон">
              {renderSelectTemplates()}
            </Form.Item>
          </Col>
          <Col>
            <Card
              headStyle={{ padding: "0 20px" }}
              title={renderCheckbox()}
              bodyStyle={styles.emails}
            >
              {account.billDeliveryEmails.map((e, index) => (
                <span key={index} className="invoice__email">
                  {e.email}
                </span>
              ))}
            </Card>
          </Col>
        </Row>
        <Form.Item
          align="center"
          style={{
            textAlign: "center",
            marginTop: "30px",
          }}
        >
          {false && ( // пока решено скрыть
            <Checkbox
              style={{ display: "block", marginBottom: "15px" }}
              checked={billsFaximileWith}
              onChange={handleChangeBillsFaximileWith}
            >
              Счет с факсимиле
            </Checkbox>
          )}
          <Button key="back" htmlType="button" onClick={history.goBack}>
            {cancelText}
          </Button>
          <Button
            style={{ marginLeft: "5px" }}
            key="submit"
            htmlType="submit"
            type="primary"
            loading={checkIsLoading(addBillLoading)}
          >
            Создать счет
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default AccountNewInvoicing;
